<template>
  <div class="loadingClass" v-if="visible">
    <!-- <div class="loadingText">加载中</div> -->
    <div class="loading-circle"></div>
    <!-- <OssImg src="images/logo3.png" class="logo"/> -->
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  visible: {
    type: Boolean,
    default: true,
  },
});
</script>

<style lang="scss" scoped>
.loadingClass {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  width: 198px;
  height: 198px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.loading-circle {
  /* #ifndef APP-NVUE */
  display: inline-flex;
  /* #endif */
  vertical-align: middle;
  width: 50px;
  height: 50px;
  background: 0 0;
  border-radius: 50%;
  border: 3px solid;
  border-color: var(--primary-color) var(--primary-color) var(--primary-color)
    rgba(0, 0, 0, 0);
  animation: u-circle 0.8s linear infinite;
}
@keyframes u-circle {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

.logo {
  width: 70px;
  height: 70px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: enlarge 0.8s linear;
}

@keyframes enlarge {
  0% {
    width: 0;
    height: 0;
  }

  100% {
    width: 70px;
    height: 70px;
  }
}
</style>
